import { TeachingBubble, TextField } from '../../fluent';
import React from 'react';
import { DateTime } from '../helpers/datetime';
import { Guid } from '../helpers/guid';
import { Column } from './Column';
import { Grid } from './Grid';
import { Row } from './Row';
export const author = {
    textAlign: 'right',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '0.8em'
};
export class TeachingComments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comments: props.comments || [],
            text: '',
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            comments: props.comments || [],
        });
    }
    render() {
        return React.createElement(TeachingBubble, { secondaryButtonProps: {
                children: 'Cerrar',
                onClick: () => this.props.onDismiss()
            }, onDismiss: () => this.props.onDismiss(), headline: 'Comments', targetElement: this.props.targetElement },
            React.createElement("div", { className: 'teaching-comments' },
                React.createElement(Grid, null,
                    React.createElement(Row, null,
                        React.createElement(Column, null,
                            React.createElement(TextField, { placeholder: 'Comment', label: 'Comment', maxLength: 128, value: this.state.text, onChange: (_, value) => {
                                    this.setState({
                                        text: value
                                    });
                                }, onKeyDown: (ev) => {
                                    if (ev.keyCode === 13) {
                                        const comments = this.state.comments;
                                        comments.push({
                                            Comment: this.state.text,
                                            Date: DateTime.Now.ToString('DD/MM/yyyy hh:mm:ss'),
                                            Id: Guid.NewGuid(),
                                            UserDisplayName: this.props.currentUserDisplayName,
                                            UserId: this.props.currentUserId,
                                            UserLoginName: this.props.currentUserLoginName,
                                        });
                                        this.props.onChange(comments);
                                        this.setState({
                                            text: ''
                                        });
                                    }
                                } }))),
                    this.state.comments.map(o => React.createElement(Row, null,
                        React.createElement(Column, null,
                            React.createElement("div", { style: { color: 'white' } }, o.Comment),
                            React.createElement("div", { className: 'author' },
                                React.createElement("div", null, o.UserDisplayName),
                                React.createElement("div", null,
                                    React.createElement("small", null, o.Date)))))))));
    }
}
